import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/packages/demo/node_modules/@marinda/gatsby-theme-recipes/src/components/MarkdownPagesLayout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Image = makeShortcode("Image");
const StyledParagraph = makeShortcode("StyledParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Image alt="About" src="/images/about.jpg" position="right" mdxType="Image" />
    <h1>{`About`}</h1>
    <StyledParagraph mdxType="StyledParagraph">A Gatsby theme for recipe enthusiasts.</StyledParagraph>
    <p>{`This is a demo site for a `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/"
      }}>{`Gatsby`}</a>{` theme for recipes. `}<a parentName="p" {...{
        "href": "https://github.com/mariiinda/gatsby-theme-recipes"
      }}>{`View the theme on Github`}</a>{` for more details. If you enjoy using it, please star it!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      